import { defineStore } from "pinia";
import { v4 as uuidv4 } from "uuid";
import { debounce } from "lodash";

export const useAlertStore = defineStore("alerts", () => {
  const alerts = ref(new Map());

  function _setAlert({ message, type = "error", errors = [] }) {
    const alertId = uuidv4();
    alerts.value.set(alertId, { id: alertId, message, type, errors });
    setTimeout(() => removeAlert(alertId), 3000);
  }

  function removeAlert(alertId) {
    alerts.value.delete(alertId);
  }

  const setAlert = debounce(_setAlert, 900, { leading: true, trailing: false });

  return { alerts, setAlert, removeAlert };
});
